import React from 'react';
import styles from './boxDetails.module.scss';
import moment from 'moment';
import 'moment-timezone';
import { divisionShort } from '../utilities/utilities';
import { getTeamConfig, getEnvConfig } from '../../config/config';
import { DualMatch, Team } from '../../graphql-types/dualMatch';
import { Wtn } from '@clubspark-react/ui';

interface BoxDetailsProps {
  data?: DualMatch;
  homeTeam?: Team;
  awayTeam?: Team;
}

const BoxDetails: React.FC<BoxDetailsProps> = ({ data, homeTeam, awayTeam }) => {
  const siteUrl = getEnvConfig().site.endsWith('/')
    ? getEnvConfig().site
    : `${getEnvConfig().site}/`;

  const timezone = (sDT: any) => {
    /* Guess the timezone */
    let thisTz = moment.tz.guess();

    if (sDT?.timezoneName !== '' && sDT?.timezoneName !== null) {
      thisTz = sDT.timezoneName;
    }

    return thisTz;
  };

  const teamUrl = getTeamConfig().teamUrl;

  return (
    <>
      <div className={styles.boxDetails}>
        <time>
          {data?.startDateTime.noScheduledTime === true
            ? moment(data?.startDateTime.dateTimeString).format('MMM D (ddd), YYYY / TBC')
            : moment(data?.startDateTime.dateTimeString)
                .tz(timezone(data?.startDateTime))
                .format('MMM D (ddd), YYYY / h:mm A z')}
        </time>
        <p className={styles.location}>{data?.location}</p>
        <div className={styles.teams}>
          <div className={`${styles.team} ${styles.right}`}>
            <div className={styles.teamLogo}>
              <img src={`${siteUrl}${awayTeam?.id}/Logo`} alt={awayTeam?.name} />
            </div>
            <div className={styles.teamName}>
              {data?.homeTeam && <p className={styles.status}>Away</p>}
              <h2>
                <a href={teamUrl + awayTeam?.id + '&a=Index&c=VenueTeam'}>{awayTeam?.name}</a>
              </h2>
              <p className={styles.division}>
                {awayTeam?.division !== null && awayTeam?.conference !== null
                  ? divisionShort(awayTeam?.division) +
                    ' ' +
                    awayTeam?.conference.replace(/_/g, ' ')
                  : null}
              </p>
              {awayTeam?.teamWtn && (
                <div className={`${styles.wtnContainer} ${styles.wtnAlignEnd}`}>
                  <p className={styles.wtnLabel}>WTN:</p>
                  <Wtn className={styles.wtnStyles} hideMark>
                    {awayTeam.teamWtn}
                  </Wtn>
                </div>
              )}
            </div>
          </div>
          <div
            className={`${styles.score} ${
              awayTeam?.score &&
              homeTeam?.score &&
              awayTeam.score.length > 2 &&
              homeTeam?.score.length > 2
                ? styles.bigScore
                : null
            }`}
          >
            <span className={styles.awayScore}>{awayTeam?.score}</span>
            <span className={styles.versus}>vs</span>
            <span className={styles.homeScore}>{homeTeam?.score}</span>
          </div>
          <div className={styles.team}>
            <div className={styles.teamLogo}>
              <img src={`${siteUrl}${homeTeam?.id}/Logo`} alt={homeTeam?.name} />
            </div>
            <div className={styles.teamName}>
              {data?.homeTeam && <p className={styles.status}>Home</p>}
              <h2>
                <a href={teamUrl + homeTeam?.id + '&a=Index&c=VenueTeam'}>{homeTeam?.name}</a>
              </h2>
              <p className={styles.division}>
                {homeTeam?.division !== null && homeTeam?.conference !== null
                  ? divisionShort(homeTeam?.division) +
                    ' ' +
                    homeTeam?.conference.replace(/_/g, ' ')
                  : null}
              </p>
              {homeTeam?.teamWtn && (
                <div className={styles.wtnContainer}>
                  <p className={styles.wtnLabel}>WTN:</p>
                  <Wtn className={styles.wtnStyles} hideMark>
                    {homeTeam.teamWtn}
                  </Wtn>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BoxDetails;
